import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Instagram } from 'lucide-react';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    if (location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
      isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
    }`}>
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20 lg:h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img 
              src="https://customer-assets.emergentagent.com/job_d2fafa34-76d1-4e50-83f7-dffe77c91e9f/artifacts/q0u25lu4_Logo.JPG" 
              alt="Ginos Friseure Logo" 
              className="h-12 lg:h-16 w-auto transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('about')}
              className="nav-link"
            >
              Über Uns
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="nav-link"
            >
              Services
            </button>
            <button 
              onClick={() => scrollToSection('prices')}
              className="nav-link"
            >
              Preise
            </button>
            <Link to="/pricelist" className="nav-link">
              Preisliste
            </Link>
            <button 
              onClick={() => scrollToSection('gallery')}
              className="nav-link"
            >
              Galerie
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="nav-link"
            >
              Kontakt
            </button>
            <a 
              href="https://www.instagram.com/ginosfriseuredusseldorf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="nav-link"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <a 
              href="https://www.treatwell.de/ort/ginos-friseure-duesseldorf/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Termin buchen
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-gray-900 hover:text-accent transition-colors"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('about')}
                className="nav-link-mobile"
              >
                Über Uns
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="nav-link-mobile"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('prices')}
                className="nav-link-mobile"
              >
                Preise
              </button>
              <Link 
                to="/pricelist" 
                className="nav-link-mobile"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Preisliste
              </Link>
              <button 
                onClick={() => scrollToSection('gallery')}
                className="nav-link-mobile"
              >
                Galerie
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="nav-link-mobile"
              >
                Kontakt
              </button>
              <a 
                href="https://www.instagram.com/ginosfriseuredusseldorf" 
                target="_blank" 
                rel="noopener noreferrer"
                className="nav-link-mobile flex items-center space-x-2"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <Instagram className="w-5 h-5" />
                <span>Instagram</span>
              </a>
              <a 
                href="https://www.treatwell.de/ort/ginos-friseure-duesseldorf/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="btn-primary text-center"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Termin buchen
              </a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
